import GlassColor from '@/data/glasscolor'

export interface IGlassOptionValue {
  id: string
  isDefault?: boolean
  name: string
  number: number
  optionId: string
  price: number
  selected: boolean
  hasExtra: number
  isExtra: number
  subtitle: string
  colorSetId: string
  subSelection: string
  colorSelection?: GlassColor
}

export default class GlassOptionValue {
  public id!: string
  public optionId!: string
  public name!: string
  public number!: number
  public price: number = 0.0
  public isDefault: boolean = false
  public selected: boolean = false
  public hasExtra: number = 0
  public isExtra: number = 0
  public subtitle!: string
  public colorSetId!: string
  public subSelection: string = ''
  public colorSelection?: GlassColor
  // meerprijs: null,
  // waarde_id: "32527c2b-b6c7-4cca-9227-1455d4bede0d",
  // kleurset_id: null,
  // default: null,
  // naam: "Chocolate Brown"
}
